import React, { useState, useRef, useEffect } from 'react';
import { NFTItemIcon } from "../Icons/NFTItemIcon";

const VideoPlayer = (props) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const {isShowNft, source} = props;
  const [isMuted, setIsMuted] = useState(true);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    
    video.addEventListener('loadedmetadata', () => {
      setDuration(video.duration);
    });

    video.addEventListener('timeupdate', () => {
      setCurrentTime(video.currentTime);
    });  
    video.addEventListener('play', () => {
      if (video.paused) {
        setIsPlaying(false);
      }else{
        setIsPlaying(true);
      }
    });
    video.addEventListener('pause', () => {
      if (video.paused) {
        setIsPlaying(false);
      }else{
        setIsPlaying(true);
      }
    });
    return () => {
      video.removeEventListener('loadedmetadata', () => {});
      video.removeEventListener('timeupdate', () => {});
      video.removeEventListener('play', () => {});
      video.removeEventListener('pause', () => {});
    };
  }, []);

  const togglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen().catch((err) => {
          console.error(`Error entering fullscreen: ${err.message}`);
        });
      } else if (videoRef.current.webkitRequestFullscreen) { // For Safari
        videoRef.current.webkitRequestFullscreen().catch((err) => {
          console.error(`Error entering fullscreen: ${err.message}`);
        });
      }
      if (videoRef.current.webkitSupportsFullscreen) {
        videoRef.current.webkitEnterFullscreen();
        return;
      }

    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { // For Safari
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return h > 0
      ? `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`
      : `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };
  const toggleMute = () => {
    setIsMuted(!isMuted);
  };
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true; 
      videoRef.current.play()
    }
    
  }, [])
  return (
    <div
        className={`${props?.className} video-inner `}
      >
        <div className={`custom-video`}>
          <div className={`mobile-video-custom ${loaded ? 'video-loaded' : ''}`}>
            <div className={`${
              loaded ? "!opacity-100" : "!opacity-0"
              } loading-transition`}>
              <video
                ref={videoRef}
                muted={isMuted}
                playsInline={true}
                loop={true}
                autoPlay={isPlaying}
                onLoadedMetadata={() => setLoaded(true)}
              >
                 <source src={source} type="video/mp4"></source>
              </video>
            </div>
            {!loaded && <div className={"w-full h-full"}>
              <img src='/assets/images/placeholder_thumbnail.gif' className='w-full object-contain' />
            </div>
            }
          </div>
          
          {isShowNft ? (
          <div className="top-[15px] absolute z-10 left-3 flex justify-start gap-2 items-center ">
              <div>
                <NFTItemIcon className="w-[40px] h-[40px]" />
              </div>
          </div>
          ) : (
            <></>
          )}
          <div className={`video-controls  z-10`}>
          <div className="flex gap-[10px] items-center justify-start">
            <button onClick={togglePlay} className="btn-video-action">
              {isPlaying ? (
                <svg
                  width="10"
                  height="12"
                  viewBox="0 0 10 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.496643 2.88818C0.496643 2.30576 0.496643 2.01454 0.572764 1.78483C0.674258 1.47854 0.868932 1.2352 1.11396 1.10833C1.29773 1.01318 1.5307 1.01318 1.99664 1.01318C2.46258 1.01318 2.69556 1.01318 2.87933 1.10833C3.12435 1.2352 3.31903 1.47854 3.42052 1.78483C3.49664 2.01454 3.49664 2.30576 3.49664 2.88818V9.13818C3.49664 9.72061 3.49664 10.0118 3.42052 10.2415C3.31903 10.5478 3.12435 10.7912 2.87933 10.918C2.69556 11.0132 2.46258 11.0132 1.99664 11.0132C1.5307 11.0132 1.29773 11.0132 1.11396 10.918C0.868932 10.7912 0.674258 10.5478 0.572764 10.2415C0.496643 10.0118 0.496643 9.72061 0.496643 9.13818V2.88818Z"
                    stroke="black"
                  />
                  <path
                    d="M6.49661 2.88818C6.49661 2.30576 6.49661 2.01454 6.57273 1.78483C6.67423 1.47854 6.8689 1.2352 7.11393 1.10833C7.2977 1.01318 7.53067 1.01318 7.99661 1.01318C8.46255 1.01318 8.69553 1.01318 8.8793 1.10833C9.12432 1.2352 9.319 1.47854 9.42049 1.78483C9.49661 2.01454 9.49661 2.30576 9.49661 2.88818V9.13818C9.49661 9.72061 9.49661 10.0118 9.42049 10.2415C9.319 10.5478 9.12432 10.7912 8.8793 10.918C8.69553 11.0132 8.46255 11.0132 7.99661 11.0132C7.53067 11.0132 7.2977 11.0132 7.11393 10.918C6.8689 10.7912 6.67423 10.5478 6.57273 10.2415C6.49661 10.0118 6.49661 9.72061 6.49661 9.13818V2.88818Z"
                    stroke="black"
                  />
                </svg>
              ) : (
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2043 5.17629C11.2652 5.75324 11.2652 7.24677 10.2043 7.82371L3.79831 11.3073C2.76718 11.868 1.5 11.1382 1.5 9.98355L1.5 3.01645C1.5 1.86184 2.76718 1.13201 3.79831 1.69274L10.2043 5.17629Z"
                    stroke="black"
                  />
                </svg>
              )}
            </button>

            <span className="btn-video-action">
              {formatTime(duration - currentTime)}
            </span>
          </div>
          <div className="flex gap-[10px] items-center justify-end">
            <button onClick={toggleMute} className="btn-video-action">
              {isMuted ? (
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_12383_6144)">
                    <path
                      d="M9.07779 6.01332C9.07779 5.73718 8.85393 5.51332 8.57779 5.51332C8.30165 5.51332 8.07779 5.73718 8.07779 6.01332H9.07779ZM4.33589 3.49238L4.41915 3.9854L4.33589 3.49238ZM5.12745 3.12344L4.85222 2.70601L4.85222 2.70601L5.12745 3.12344ZM4.69176 3.38562L4.89364 3.84305L4.69176 3.38562ZM2.49773 8.37468L2.28778 8.82846L2.49773 8.37468ZM1.59518 6.52752L1.09611 6.55794L1.59518 6.52752ZM1.80706 7.72482L2.24723 7.48766L1.80706 7.72482ZM7.67782 10.0508L7.51633 9.57758L7.67782 10.0508ZM8.53415 7.31602L9.03361 7.33922L8.53415 7.31602ZM7.96764 9.9033L8.25513 10.3124L7.96764 9.9033ZM5.23692 3.05126L5.51215 3.46869L5.51215 3.46869L5.23692 3.05126ZM7.67782 1.97586L7.51633 2.44907L7.67782 1.97586ZM7.96764 2.12335L8.25513 1.71426V1.71426L7.96764 2.12335ZM2.49773 3.65197L2.28778 3.19818L2.49773 3.65197ZM1.59518 5.49912L1.09611 5.4687L1.59518 5.49912ZM1.80706 4.30182L2.24723 4.53899L1.80706 4.30182ZM5.85184 8.78149C5.62087 8.63014 5.31094 8.69468 5.15958 8.92565C5.00823 9.15662 5.07277 9.46655 5.30374 9.6179L5.85184 8.78149ZM5.40268 3.54087L5.51215 3.46869L4.96169 2.63383L4.85222 2.70601L5.40268 3.54087ZM2.09426 6.4971C2.08379 6.32539 2.07779 6.16174 2.07779 6.01332H1.07779C1.07779 6.18731 1.08478 6.37204 1.09611 6.55794L2.09426 6.4971ZM2.07779 6.01332C2.07779 5.86491 2.08379 5.70125 2.09426 5.52954L1.09611 5.4687C1.08478 5.65461 1.07779 5.83934 1.07779 6.01332H2.07779ZM8.07779 6.01332C8.07779 6.26586 8.06072 6.73264 8.03469 7.29281L9.03361 7.33922C9.0595 6.78212 9.07779 6.29267 9.07779 6.01332H8.07779ZM3.82783 4.01332C4.06757 4.01332 4.2443 4.01493 4.41915 3.9854L4.25263 2.99936C4.17947 3.01172 4.10016 3.01332 3.82783 3.01332V4.01332ZM4.85222 2.70601C4.62486 2.85591 4.55777 2.89823 4.48988 2.92819L4.89364 3.84305C5.05587 3.77146 5.20253 3.67283 5.40268 3.54087L4.85222 2.70601ZM4.41915 3.9854C4.5826 3.9578 4.74199 3.90998 4.89364 3.84305L4.48988 2.92819C4.41406 2.96165 4.33436 2.98556 4.25263 2.99936L4.41915 3.9854ZM3.82783 9.01332C4.10016 9.01332 4.17947 9.01493 4.25263 9.02728L4.41915 8.04124C4.2443 8.01172 4.06757 8.01332 3.82783 8.01332V9.01332ZM3.82783 8.01332C3.09437 8.01332 2.884 8.00247 2.70768 7.92089L2.28778 8.82846C2.71079 9.02418 3.18738 9.01332 3.82783 9.01332V8.01332ZM1.09611 6.55794C1.1307 7.12547 1.14697 7.55382 1.36689 7.96199L2.24723 7.48766C2.15392 7.31447 2.13335 7.13841 2.09426 6.4971L1.09611 6.55794ZM2.70768 7.92089C2.53204 7.83963 2.33903 7.65803 2.24723 7.48766L1.36689 7.96199C1.56128 8.32277 1.91584 8.65638 2.28778 8.82846L2.70768 7.92089ZM8.03469 7.29281C7.99895 8.06186 7.97345 8.5879 7.90552 8.96525C7.83801 9.34026 7.74768 9.44676 7.68014 9.49422L8.25513 10.3124C8.64895 10.0356 8.80682 9.60282 8.8897 9.14242C8.97216 8.68437 8.99924 8.07888 9.03361 7.33922L8.03469 7.29281ZM7.8393 10.524C7.98645 10.4738 8.12792 10.4018 8.25513 10.3124L7.68014 9.49422C7.63044 9.52915 7.57383 9.55796 7.51633 9.57758L7.8393 10.524ZM5.51215 3.46869C6.1601 3.04147 6.60455 2.74967 6.95252 2.58063C7.29919 2.41223 7.43917 2.42273 7.51633 2.44907L7.8393 1.50266C7.3828 1.34687 6.93807 1.47591 6.51557 1.68115C6.09438 1.88575 5.58522 2.22271 4.96169 2.63383L5.51215 3.46869ZM7.51633 2.44907C7.57383 2.46869 7.63044 2.4975 7.68014 2.53243L8.25513 1.71426C8.12792 1.62486 7.98645 1.55287 7.8393 1.50266L7.51633 2.44907ZM3.82783 3.01332C3.18738 3.01332 2.71079 3.00247 2.28778 3.19818L2.70768 4.10575C2.884 4.02417 3.09437 4.01332 3.82783 4.01332V3.01332ZM2.09426 5.52954C2.13335 4.88823 2.15392 4.71217 2.24723 4.53899L1.36689 4.06465C1.14697 4.47282 1.1307 4.90117 1.09611 5.4687L2.09426 5.52954ZM2.28778 3.19818C1.91584 3.37026 1.56128 3.70387 1.36689 4.06465L2.24723 4.53899C2.33903 4.36861 2.53204 4.18701 2.70768 4.10575L2.28778 3.19818ZM5.30374 9.6179C5.82147 9.95717 6.25994 10.2351 6.63744 10.4021C7.02115 10.5719 7.42524 10.6653 7.8393 10.524L7.51633 9.57758C7.44669 9.60134 7.32516 9.61286 7.04197 9.4876C6.75257 9.35958 6.38288 9.12948 5.85184 8.78149L5.30374 9.6179ZM9.01416 4.27715C8.98395 3.66555 8.95068 3.15211 8.86341 2.75158C8.77452 2.34365 8.61179 1.96492 8.25513 1.71426L7.68014 2.53243C7.74112 2.57528 7.82136 2.66629 7.88633 2.96448C7.95292 3.27007 7.98439 3.69911 8.01538 4.32649L9.01416 4.27715Z"
                      fill="black"
                    />
                    <path
                      d="M10.8278 9.01316C10.8278 9.01316 11.5778 8.11316 11.5778 6.01316C11.5778 4.79647 11.326 3.98259 11.1142 3.51318"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.82779 7.51318C9.82779 7.51318 10.0778 7.06318 10.0778 6.01318C10.0778 5.58224 10.0357 5.25236 9.98602 5.01318"
                      stroke="black"
                      strokeLinecap="round"
                    />
                    <path
                      d="M11.8278 1.01318L1.82779 11.0132"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_12383_6144">
                      <rect
                        width="12"
                        height="12"
                        fill="white"
                        transform="translate(0.827789 0.0131836)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.767395 5.98569C0.804234 5.38128 0.822653 5.07907 0.97927 4.78839C1.12236 4.52282 1.39615 4.26521 1.66994 4.13854C1.9696 3.99989 2.31308 3.99989 3.00004 3.99989C3.25608 3.99989 3.38409 3.99989 3.5081 3.97895C3.63069 3.95825 3.75023 3.92239 3.86397 3.87219C3.97903 3.82141 4.08591 3.75095 4.29966 3.61001L4.40913 3.53783C5.68061 2.69949 6.31636 2.28032 6.85003 2.46244C6.95235 2.49735 7.05139 2.54775 7.13985 2.60992C7.6012 2.93415 7.63625 3.6885 7.70636 5.1972C7.73232 5.75583 7.75 6.23395 7.75 6.49989C7.75 6.76584 7.73232 7.24395 7.70636 7.80259C7.63625 9.31129 7.6012 10.0656 7.13985 10.3899C7.05139 10.452 6.95235 10.5024 6.85003 10.5374C6.31636 10.7195 5.68061 10.3003 4.40913 9.46196L4.29966 9.38978C4.0859 9.24884 3.97903 9.17837 3.86397 9.1276C3.75023 9.0774 3.63069 9.04154 3.5081 9.02083C3.38409 8.99989 3.25608 8.99989 3.00004 8.99989C2.31308 8.99989 1.9696 8.99989 1.66994 8.86125C1.39615 8.73458 1.12236 8.47697 0.97927 8.2114C0.822653 7.92072 0.804234 7.61851 0.767395 7.01409C0.756496 6.83529 0.75 6.66109 0.75 6.49989C0.75 6.33869 0.756496 6.1645 0.767395 5.98569Z"
                    stroke="black"
                  />
                  <path
                    d="M10 3.5C10 3.5 10.75 4.4 10.75 6.5C10.75 8.6 10 9.5 10 9.5"
                    stroke="black"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9 5C9 5 9.25 5.45 9.25 6.5C9.25 7.55 9 8 9 8"
                    stroke="black"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </button>

            {
              !isFullscreen ?  <button onClick={toggleFullscreen} className="btn-video-action">
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 4.5L11 0.5M11 0.5L8 0.5M11 0.5L11 3.5"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 6.5L1 10.5M1 10.5L4 10.5M1 10.5L1 7.5"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>: <button onClick={toggleFullscreen} className="btn-video-action">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 1L11.8 8.2M11.8 8.2L17.2 8.2M11.8 8.2L11.8 2.8" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1 19L8.2 11.8M8.2 11.8L2.8 11.8M8.2 11.8L8.2 17.2" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>

              </button>
              }
          </div>
        </div>
        </div>
      </div>
  );
};

export default VideoPlayer;